import { authHeader, BASE_URL, handleResponse } from '@helpers/api';
import { ProductEvent } from '@constants/product-events';
import { captureOnSuccess } from '@helpers/product-events';

export const linkedinIntegrationService = {
    getAuthorizeUrl,
    connectIntegration,
    disconnectIntegration,
    getTargets,
    connectLocation,
};

function getAuthorizeUrl() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/linkedin/authorize-url`, requestOptions).then(handleResponse);
}

function connectIntegration(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/linkedin/connect-integration`, requestOptions)
        .then(handleResponse)
        .then(captureOnSuccess(ProductEvent.IntegrationConnected, { integration: 'linkedin' }));
}

function disconnectIntegration(integrationId) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
    };

    const query = integrationId ? `?integrationId=${integrationId}` : '';
    return fetch(`${BASE_URL}api/linkedin/disconnect-integration${query}`, requestOptions).then(handleResponse);
}

// Lists the LinkedIn authors a location can connect to for the chosen LinkedIn account: the personal
// profile plus any administered organization Pages (when the Community Management API is enabled).
function getTargets(integrationId = null) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    const query = integrationId ? `?integrationId=${integrationId}` : '';
    return fetch(`${BASE_URL}api/linkedin/targets${query}`, requestOptions).then(handleResponse);
}

function connectLocation(locationId, integrationId, target) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify({
            integrationId,
            authorUrn: target?.urn,
            name: target?.name,
        }),
    };

    return fetch(`${BASE_URL}api/locations/${locationId}/integrations/linkedin:connect`, requestOptions).then(
        handleResponse,
    );
}
